import './index.scss';
import {inject, observer} from 'mobx-react';
import ModuleTitle from '../ModuleTitle';
@inject(({store}) => ({
    gnrmmdd: store.gnrmmdd,
    jump: store.jump,
    ymbj: store.ymbj
}))
@observer
class PopDest extends React.Component {
    render() {
        const {gnrmmdd, jump, ymbj} = this.props;
        if((ymbj.rmmddpz && ymbj.rmmddpz.switch !== 1) || !gnrmmdd.length) return null;
        return(
            <div className="m-popdeest m-floor" id="rmmddpz">
                <ModuleTitle name="rmmddpz"/>
                <div className="lists g-flexbox">
                    {
                        gnrmmdd.map((item, index) => {
                            return <div className="list-item" key={index} onClick={() => {
                                jump(item.jumpInfo, 'shuqi_gn_mdd');
                                sendSk(`click_gn_mdd${index+1}`);
                            }}>
                                <div className="cover"><img src={item.img} alt=""/></div>
                                <div className="city">{item.module.query}</div>
                                <div className="desc">{item.desc}</div>
                                <div className="b g-flexbox">
                                    <div className="price">&yen;<span>{item.module.taocanPrice || item.module.price}</span>起</div>
                                    <span className="yo-ico"></span>
                                </div>
                            </div>;
                        })
                    }

                </div>
            </div>
        );
    }
}

export default PopDest;